import { GLOBALS } from 'constants/settings';

class Fader {
  constructor(selector = '.js-fader.js-fader-inactive') {

    this.selector = selector;
    this.$targets = document.querySelectorAll(this.selector);

    ['scroll', 'resize'].forEach((e) => {
      window.addEventListener(e, (f) => {
        this.fadeElements();
      });
    });

    this.fadeElements();
    setTimeout((e) => {
      this.fadeElements();
    }, GLOBALS.transition);
  }

  fadeElements() {
    let scrollTop = (window.pageYOffset !== undefined) ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
    let winHeight = window.innerHeight;

    let threshold = scrollTop + winHeight;
    this.$targets.forEach(($target) => {
      if ($($target).offset().top < threshold) {
        let delay = ($target.dataset.jsFaderDelay) ? parseInt($target.dataset.jsFaderDelay) : 0;
        setTimeout(() => {
          $target.classList.remove('js-fader-inactive');
        }, (delay / 2.5) * GLOBALS.transition);
      }
    });

    this.$targets = document.querySelectorAll(this.selector);
  }
}

export default Fader;



// WEBPACK FOOTER //
// ./app/javascript/global/fader.js